export default __webpack_public_path__ + "static/media/SJA1480.34I-42071_-25219_0.5b6f2efb.jpg";